"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("../base");

var DataApi =
/** @class */
function (_super) {
  __extends(DataApi, _super);

  function DataApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Gets representation of query to be sent to your database engine
     */


    _this.getQuery = function (request, requestOptions) {
      return _this.post({
        path: "/query/get",
        body: request,
        requestOptions: requestOptions
      });
    };
    /**
     * Gets the data in JSON format
     */


    _this.getData = function (request, requestOptions) {
      return _this.post({
        path: "/data/get",
        body: request,
        requestOptions: requestOptions
      });
    };
    /**
     * Gets the data in optimized JSON format
     */


    _this.getDataOptimized = function (request, requestOptions) {
      return _this.post({
        path: "/data/getoptimized",
        body: request,
        requestOptions: requestOptions
      });
    };
    /**
     * Gets data in CSV format
     */


    _this.getCSV = function (request, requestOptions) {
      return _this.post({
        path: "/file/get",
        body: request,
        requestOptions: requestOptions
      });
    };
    /**
     * Gets data in Excel format
     */


    _this.getExcel = function (request, requestOptions) {
      return _this.post({
        path: "/file/getexcel",
        body: request,
        requestOptions: requestOptions
      });
    };

    return _this;
  }

  return DataApi;
}(base_1.BaseApi);

exports.DataApi = DataApi;